import {
    UPDATE_POINT_SYSTEM_ERROR,
    UPDATE_POINT_SYSTEM_LOADING,
    UPDATE_POINT_SYSTEM_SUCCESS,
} from "../../../constant/actionTypes";

const updatePointSystemReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_POINT_SYSTEM_LOADING: {
            let obj = {
                loading: true,
            };
            return obj;
        }
        case UPDATE_POINT_SYSTEM_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response,
            };
            return obj;
        }
        case UPDATE_POINT_SYSTEM_ERROR: {
            let obj = {
                loading: false,
                status: action.response,
            };
            return obj;
        }
        default:
            return state;
    }
};

export default updatePointSystemReducer;
